import { render } from "./logo.vue?vue&type=template&id=bd0e174a"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"

import "./logo.vue?vue&type=style&index=0&id=bd0e174a&lang=scss"

import exportComponent from "D:\\Development\\vue\\okraina.sbs.monitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__